import React, { useState } from "react";

import "bootstrap/dist/css/bootstrap.min.css";

import "../../Styles/GlobalNetwork123.css";

import event1Image from "../../assets/globel2.png";
import event2Image from "../../assets/global3.png";
import video from "../../assets/globe.mp4";
import RegisterGTPopupService from "../RegisterGTPopupService"; // <-- Add import

const GlobalNetwork = () => {
  const [showPopup, setShowPopup] = useState(false);

  const openPopup = () => setShowPopup(true);
  const closePopup = () => setShowPopup(false);

  const events = [
    {
      image: event1Image,
      title: "HR EVENT",
      organizer: "K. Siva Krishna",
      speaker: "K. Rajasekhar",
      eventmode: "In Person",
      schedule: "Aug 20 - Aug 23",
      time: "10AM - 4PM",
      location: "Ameerpet",
    },
    {
      image: event2Image,
      title: "HR EVENT",
      organizer: "K. Siva Krishna",
      speaker: "K. Rajasekhar",
      eventmode: "Online",
      schedule: "Jun 20 - Jun 23",
      time: "10AM - 4PM",
      location: "Ameerpet",
    },
  ];

  return (
    <>
      <section className="globalnetwork123-wrapper" id="global">
        <div className="globalnetwork123-section">
          {/* ===================== HERO: VIDEO LEFT + CONTENT RIGHT ===================== */}
          <div className="globalnetwork123-hero">
            <div className="globalnetwork123-hero-video">
              <div className="globalnetwork123-video-container">
                <video
                  src={video}
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="globalnetwork123-video"
                />
              </div>
            </div>

            <div className="globalnetwork123-hero-content">
              {/* <span className="globalnetwork123-small-badge">
                <span className="globalnetwork123-badge-icon">🌐</span>
                Global Networking
              </span> */}

              <h3 className="globalnetwork123-title">GLOBAL NETWORKING</h3>
              <div className="globalnetwork123-title-line"></div>

              <p className="globalnetwork123-description">
                We provide global networking solutions that help businesses
                connect, collaborate, and scale across borders. With secure
                infrastructure and 24/7 support, we help you build a reliable
                network that grows with your business and ensures smooth,
                uninterrupted operations.
              </p>
              <p className="globalnetwork123-description globalnetwork123-description-second">
                Our ecosystem delivers high-speed connectivity.
              </p>
            </div>
          </div>

          {/* ===================== EVENT CARDS ===================== */}
          <div className="globalnetwork123-program-list">
            <div className="globalnetwork123-grid">
              {events.map((event, index) => (
                <div className="globalnetwork123-card" key={index}>
                  <div className="globalnetwork123-card-content">
                    <h4 className="globalnetwork123-card-title">{event.title}</h4>
                    <div className="globalnetwork123-card-title-line"></div>

                    <div className="globalnetwork123-detail">
                      <span className="globalnetwork123-detail-icon">👤</span>
                      <span className="globalnetwork123-detail-text">
                        <span className="globalnetwork123-detail-label">
                          Organizer:
                        </span>
                        <strong>{event.organizer}</strong>
                      </span>
                    </div>

                    <div className="globalnetwork123-detail">
                      <span className="globalnetwork123-detail-icon">🎤</span>
                      <span className="globalnetwork123-detail-text">
                        <span className="globalnetwork123-detail-label">
                          Speaker:
                        </span>
                        <strong>{event.speaker}</strong>
                      </span>
                    </div>

                    <div className="globalnetwork123-detail">
                      <span className="globalnetwork123-detail-icon">💻</span>
                      <span className="globalnetwork123-detail-text">
                        <span className="globalnetwork123-detail-label">
                          Event Mode:
                        </span>
                        <strong>{event.eventmode}</strong>
                      </span>
                    </div>

                    <div className="globalnetwork123-detail">
                      <span className="globalnetwork123-detail-icon">📅</span>
                      <span className="globalnetwork123-detail-text">
                        <span className="globalnetwork123-detail-label">
                          Schedule:
                        </span>
                        <strong>{event.schedule}</strong>
                      </span>
                    </div>

                    <div className="globalnetwork123-detail">
                      <span className="globalnetwork123-detail-icon">⏰</span>
                      <span className="globalnetwork123-detail-text">
                        <span className="globalnetwork123-detail-label">
                          Time:
                        </span>
                        <strong>{event.time}</strong>
                      </span>
                    </div>

                    <div className="globalnetwork123-detail">
                      <span className="globalnetwork123-detail-icon">📍</span>
                      <span className="globalnetwork123-detail-text">
                        <span className="globalnetwork123-detail-label">
                          Location:
                        </span>
                        <strong>{event.location}</strong>
                      </span>
                    </div>

                    <button
                      className="globalnetwork123-register-btn"
                      onClick={openPopup}
                    >
                      REGISTER NOW
                      <span className="globalnetwork123-register-arrow">→</span>
                    </button>
                  </div>

                  <div className="globalnetwork123-card-image-wrapper">
                    <img
                      src={event.image}
                      alt={event.title}
                      className="globalnetwork123-card-image"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Popup Component */}
      <RegisterGTPopupService show={showPopup} onClose={closePopup} />
    </>
  );
};

export default GlobalNetwork;